var map = {
	"./frontend/AndroidGuide.vue": 97881,
	"./frontend/Banking.vue": 60534,
	"./frontend/BetslipHistory.vue": 47984,
	"./frontend/BodyFB.vue": 10899,
	"./frontend/Commission.vue": 52770,
	"./frontend/ContactUs.vue": 35571,
	"./frontend/DataTable.vue": 36107,
	"./frontend/Deposit.vue": 25743,
	"./frontend/History.vue": 38259,
	"./frontend/Home.vue": 14945,
	"./frontend/IOSGuide.vue": 7508,
	"./frontend/Iframe copy.vue": 34991,
	"./frontend/Iframe.vue": 38823,
	"./frontend/Index.vue": 62760,
	"./frontend/Live.vue": 61005,
	"./frontend/LiveScore.vue": 72184,
	"./frontend/MainMenu.vue": 43595,
	"./frontend/MaungFB.vue": 56141,
	"./frontend/Promotion.vue": 12745,
	"./frontend/Setting.vue": 79122,
	"./frontend/VideoLink.vue": 96211,
	"./frontend/VipLevels.vue": 1248,
	"./frontend/Withdraw.vue": 12641,
	"./frontend/auth/Login.vue": 85414,
	"./frontend/auth/Register.vue": 12294,
	"./frontend/auth/Rule.vue": 24557,
	"./frontend/auth/Verify.vue": 72659,
	"./frontend/auth/VerifyNotAuth.vue": 2395,
	"./frontend/components/AccountSelect.vue": 3678,
	"./frontend/components/DataTable.vue": 40093,
	"./frontend/components/FBPreviewVoucher.vue": 81723,
	"./frontend/components/FBVoucher.vue": 9650,
	"./frontend/components/FootballTeamCard.vue": 23512,
	"./frontend/components/GroupBox.vue": 48747,
	"./frontend/components/InputSelectDrawModal.vue": 90313,
	"./frontend/components/LuckyWheel.vue": 30187,
	"./frontend/components/NormalBox.vue": 63243,
	"./frontend/components/PreviewVoucher.vue": 47750,
	"./frontend/components/SideNav.vue": 30850,
	"./frontend/components/Table.vue": 66459,
	"./frontend/components/ThreedGroupBox.vue": 95959,
	"./frontend/components/TwoDSelect.vue": 89795,
	"./frontend/components/Voucher.vue": 49780,
	"./frontend/normal-user/2d/2d.vue": 74306,
	"./frontend/normal-user/2d/ClosedDays.vue": 96899,
	"./frontend/normal-user/2d/Home.vue": 90292,
	"./frontend/normal-user/2d/Winner.vue": 70630,
	"./frontend/normal-user/3d/3d.vue": 3096,
	"./frontend/normal-user/3d/Home.vue": 26470,
	"./frontend/normal-user/DreamBooks.vue": 46314,
	"./frontend/normal-user/Index.vue": 56012,
	"./frontend/normal-user/bugyee/Room.vue": 7576,
	"./frontend/normal-user/game/Arcade.vue": 64964,
	"./frontend/normal-user/game/Fishing.vue": 32919,
	"./frontend/normal-user/game/Game.vue": 91217,
	"./frontend/normal-user/game/Slot.vue": 93388,
	"./frontend/normal-user/shankomee/Room.vue": 23084
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5477;